import { useContext, useEffect, useState } from 'react'
import html2pdf from 'html2pdf.js';
import { loginUserId } from './LoginUserIdContext';
import { IdContext } from './userIdContext';
import './DownloadAndPrint.css'
import { useNavigate } from 'react-router-dom';
import { FiDownload } from "react-icons/fi";
import { IoMdPrint } from "react-icons/io";
import { BiSolidFileImport } from "react-icons/bi";
import { FaFilePdf } from "react-icons/fa6";
import ImportData from './ImportData';
import { useMediaQuery } from 'react-responsive';
import { IoMdArrowRoundBack } from "react-icons/io";




export default function DownloadAndPrint() {
    const [infoooPatients, setInfoooPatients] = useState([])
    const [infoooTreatments, setInfoooTreatments] = useState([])
    const [infoooPayments, setInfoooPayments] = useState([])
    const [infoooTreatmentsExtra, setInfoooTreatmentsExtra] = useState([])
    const [infoooSessions, setInfoooSessions] = useState([])
    const [infoooPatientsArray, setInfoooPatientsArray] = useState([])
    const [infoooTreatmentsArray, setInfoooTreatmentsArray] = useState([])
    const [infoooPatientTreatment, setInfoooPatientTreatment] = useState([])
    const [infoooSessionsArray, setInfoooSessionsArray] = useState([])
    const [cannals, setCannals] = useState([]);
    const [message, setMessage] = useState("")
    const { id } = useContext(loginUserId)
    const domainUrl= "drclinic.hassan-mohammad.tech"

    const getPataintsData = async () => {
        setMessage('Loading...')
        await fetch(`https://${domainUrl}/php/getPatients.php?loginuserid=${id}`,
            {
                headers: {
                    "Content-Type": "text/html",
                    "charset": "utf-8"
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    throw Error('Could not fetch the data')

                }
                else if (response.ok) {
                    return response.json()
                }
            })
            .then((data) => {
                if (data.successful) {
                    setMessage('Done')
                    data.values.map((e) => {
                        infoooPatientsArray.push(e)
                        getSessionsData(e.id)
                        getPaymentsData(e.id)
                    })
                }
                return setInfoooPatients(data.values)

            })
            .catch(err => {
                setMessage(err)
            })
    };


    const getTreatmentsData = async (PatientId, SessionId) => {
        await fetch(`https://${domainUrl}/php/getidTreats.php?sessionid=${SessionId}&userid=${PatientId}&loginuserid=${id}`,
            {
                headers: {
                    "Content-Type": "text/html",
                    "charset": "utf-8"
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    throw Error('Could not fetch the data')

                }
                else if (response.ok) {
                    return response.json()
                }
            })
            .then((data) => {
                if (data.successful) {
                    data.values.map((e) => {
                        if (e.treatmentType === "Root canal treatment" && e.cannals.length > 0) {
                            setCannals(JSON.parse(e.cannals))
                        }
                        //infoooTreatmentsArray.push(e)
                    })
                    setMessage('Done')
                }
                return setInfoooTreatmentsExtra(data.values)

            })
            .catch(err => {
                setMessage(err)
            })
    };




    const getTreatmentsUserData = async (PatientId, SessionId) => {
        await fetch(`https://${domainUrl}/php/getdownloadData.php?sessionid=${SessionId}&userid=${PatientId}&loginuserid=${id}`,
            {
                headers: {
                    "Content-Type": "text/html",
                    "charset": "utf-8"
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    throw Error('Could not fetch the data')

                }
                else if (response.ok) {
                    return response.json()
                }
            })
            .then((data) => {
                if (data.successful) {
                    data.values.map((e) => {
                        if (e.treatmentType === "Root canal treatment" && e.cannals.length > 0) {
                            setCannals(JSON.parse(e.cannals))
                        }
                        //infoooTreatmentsArray.push(e)
                    })
                }
                return setInfoooTreatments(data.values)

            })
            .catch(err => {
                setMessage(err)
            })
    };
    const cannalsItems = cannals.map((canal) => {
        return (
            <td>{canal.cannalName}{canal.cannalLength}</td>
        )
    })

    console.log(`infootreatuser ${JSON.stringify(infoooTreatments)}`)

    const getPaymentsData = async (patientId) => {
        await fetch(`https://${domainUrl}/php/getpaymentsDownload.php?userid=${patientId}&loginuserid=${id}`,
            {
                headers: {
                    "Content-Type": "text/html",
                    "charset": "utf-8"
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    throw Error('Could not fetch the data')

                }
                else if (response.ok) {
                    return response.json()
                }
            })
            .then((data) => {
                if (data.successful) {
                    setMessage('Done')
                }
                return setInfoooPayments(data.values)

            })
            .catch(err => {
                setMessage(err)
            })
    };


    async function getSessionsData(PatientId) {
        await fetch(`https://${domainUrl}/php/getidSessions.php?userid=${PatientId}&loginuserid=${id}`,
            {
                headers: {
                    "Content-Type": "text/html",
                    "charset": "utf-8"
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    throw Error('Could not fetch the data')

                }
                else if (response.ok) {
                    return response.json()
                }
            })
            .then(async (data) => {
                if (data.successful) {
                    data.values.map((e) => {
                        infoooSessionsArray.push(e)
                        getTreatmentsUserData(PatientId, e.id)
                    })

                }
                return setInfoooSessions(data.values)

            })
            .catch(err => {
                setMessage(err)
            })
    };

    const handleExport = async () => {
        try {
            const response = await fetch(`https://${domainUrl}/php/exportdata.php?loginuserid=${id}`,
                {
                    headers: {
                        "Content-Type": "text/html",
                        "charset": "utf-8"
                    },
                });

            if (!response.ok) {
                throw new Error("Failed to download file");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = `user_${id}_data.csv`;

            document.body.appendChild(link);
            link.click();
            link.remove();

            // Clean up the blob URL
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Export failed:", error);
            alert("An error occurred while exporting data.");
        }
    };


    function getAllData() {
        getPataintsData()
    }

    const navigate = useNavigate();
    function back() {
        window.history.pushState({ id: 1 }, null, "Download")
        navigate("/GetPatients", { replace: true });
    }

    const patientData = infoooPatients.map((e) => {
        return (
            <section>
                <div className="patients-download">
                    <div className="patients-item-download">
                        <p><b>Name</b></p>
                        <p>{e.name} </p>
                    </div>
                    <div className="patients-item-download">
                        <p><b>Age</b></p>
                        <p>{e.age}</p>
                    </div>
                    <div className="patients-item-download">
                        <p><b>Gender</b></p>
                        <p>{e.sex}</p>
                    </div>
                    <div className="patients-item-download">
                        <p><b>Phone</b></p>
                        <p>{e.phone}</p>
                    </div>
                    <div className="patients-item-download">
                        <p><b>Notes</b></p>
                        <p>{e.notes}</p>
                    </div>
                    <div className="patients-item-download">
                        <p><b>Costs</b></p>
                        <p>{e.costssum}</p>
                    </div>
                    <div className="patients-item-download">
                        <p><b>Payments</b></p>
                        <p>{e.paymentssum}</p>
                    </div>
                    <div className="patients-item-download">
                        <p><b>Sessions Num</b></p>
                        <p>{e.sessionsnum}</p>
                    </div>
                </div>
            </section>
        )
    })

    const paymentsData = infoooPayments.map((e) => {
        return (
            <section>
                <div className="payments-download">
                    <div className="patients-item-download">
                        <p><b>Name</b></p>
                        <p>{e.name} </p>
                    </div>
                    <div className="patients-item-download">
                        <p><b>Amount</b></p>
                        <p>{e.amount}</p>
                    </div>
                    <div className="patients-item-download">
                        <p><b>Date</b></p>
                        <p>{e.date}</p>
                    </div>
                </div>
            </section>
        )
    })



    const treatmentsPatientsData = infoooTreatments.map((e) => {
        return (
            <section>
                <div className="download-container">
                    <h5>Treatment</h5>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}><h6 >Name: </h6><h6>{e.name}</h6></div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}><h6>Date:</h6><h6>{e.date}</h6></div>
                    </div>
                    <div className="download-container-in" >
                        {e.tooth && <div><h5>Tooth</h5>
                            {(e.tooth === '1RD' || e.tooth === '1RDP') && <p>{31}</p>}
                            {(e.tooth === '2RD' || e.tooth === '2RDP') && <p>{32}</p>}
                            {(e.tooth === '3RD' || e.tooth === '3RDP') && <p>{33}</p>}
                            {(e.tooth === '4RD' || e.tooth === '4RDP') && <p>{34}</p>}
                            {(e.tooth === '5RD' || e.tooth === '5RDP') && <p>{35}</p>}
                            {(e.tooth === '6RD' || e.tooth === '6RDP') && <p>{36}</p>}
                            {(e.tooth === '7RD' || e.tooth === '7RDP') && <p>{37}</p>}
                            {(e.tooth === '8RD' || e.tooth === '8RDP') && <p>{38}</p>}
                            {(e.tooth === '1LD' || e.tooth === '1LDP') && <p>{41}</p>}
                            {(e.tooth === '2LD' || e.tooth === '2LDP') && <p>{42}</p>}
                            {(e.tooth === '3LD' || e.tooth === '3LDP') && <p>{43}</p>}
                            {(e.tooth === '4LD' || e.tooth === '4LDP') && <p>{44}</p>}
                            {(e.tooth === '5LD' || e.tooth === '5LDP') && <p>{45}</p>}
                            {(e.tooth === '6LD' || e.tooth === '6LDP') && <p>{46}</p>}
                            {(e.tooth === '7LD' || e.tooth === '7LDP') && <p>{47}</p>}
                            {(e.tooth === '8LD' || e.tooth === '8LDP') && <p>{48}</p>}
                            {(e.tooth === '1RU' || e.tooth === '1RUP') && <p>{21}</p>}
                            {(e.tooth === '2RU' || e.tooth === '2RUP') && <p>{22}</p>}
                            {(e.tooth === '3RU' || e.tooth === '3RUP') && <p>{23}</p>}
                            {(e.tooth === '4RU' || e.tooth === '4RUP') && <p>{24}</p>}
                            {(e.tooth === '5RU' || e.tooth === '5RUP') && <p>{25}</p>}
                            {(e.tooth === '6RU' || e.tooth === '6RUP') && <p>{26}</p>}
                            {(e.tooth === '7RU' || e.tooth === '7RUP') && <p>{27}</p>}
                            {(e.tooth === '8RU' || e.tooth === '8RUP') && <p>{28}</p>}
                            {(e.tooth === '1LU' || e.tooth === '1LUP') && <p>{11}</p>}
                            {(e.tooth === '2LU' || e.tooth === '2LUP') && <p>{12}</p>}
                            {(e.tooth === '3LU' || e.tooth === '3LUP') && <p>{13}</p>}
                            {(e.tooth === '4LU' || e.tooth === '4LUP') && <p>{14}</p>}
                            {(e.tooth === '5LU' || e.tooth === '5LUP') && <p>{15}</p>}
                            {(e.tooth === '6LU' || e.tooth === '6LUP') && <p>{16}</p>}
                            {(e.tooth === '7LU' || e.tooth === '7LUP') && <p>{17}</p>}
                            {(e.tooth === '8LU' || e.tooth === '8LUP') && <p>{18}</p>}
                            {(e.tooth === '1RUT' || e.tooth === '1RUTP') && <p>{51}</p>}
                            {(e.tooth === '2RUT' || e.tooth === '2RUTP') && <p>{52}</p>}
                            {(e.tooth === '3RUT' || e.tooth === '3RUTP') && <p>{53}</p>}
                            {(e.tooth === '4RUT' || e.tooth === '4RUTP') && <p>{54}</p>}
                            {(e.tooth === '5RUT' || e.tooth === '5RUTP') && <p>{55}</p>}
                            {(e.tooth === '1LUT' || e.tooth === '1LUTP') && <p>{61}</p>}
                            {(e.tooth === '2LUT' || e.tooth === '2LUTP') && <p>{62}</p>}
                            {(e.tooth === '3LUT' || e.tooth === '3LUTP') && <p>{63}</p>}
                            {(e.tooth === '4LUT' || e.tooth === '4LUTP') && <p>{64}</p>}
                            {(e.tooth === '5LUT' || e.tooth === '5LUTP') && <p>{65}</p>}
                            {(e.tooth === '1RDT' || e.tooth === '1RDTP') && <p>{81}</p>}
                            {(e.tooth === '2RDT' || e.tooth === '2RDTP') && <p>{82}</p>}
                            {(e.tooth === '3RDT' || e.tooth === '3RDTP') && <p>{83}</p>}
                            {(e.tooth === '4RDT' || e.tooth === '4RDTP') && <p>{84}</p>}
                            {(e.tooth === '5RDT' || e.tooth === '5RDTP') && <p>{85}</p>}
                            {(e.tooth === '1LDT' || e.tooth === '1LDTP') && <p>{71}</p>}
                            {(e.tooth === '2LDT' || e.tooth === '2LDTP') && <p>{72}</p>}
                            {(e.tooth === '3LDT' || e.tooth === '3LDTP') && <p>{73}</p>}
                            {(e.tooth === '4LDT' || e.tooth === '4LDTP') && <p>{74}</p>}
                            {(e.tooth === '5LDT' || e.tooth === '5LDTP') && <p>{75}</p>}
                        </div>}
                        {e.status && <div><h5>Status</h5><p>{e.status}</p></div>}
                        {e.inclinic && <div><h5>Place of Treatment</h5><p>{e.inclinic}</p></div>}
                        {e.treatmentType && <div> <h5>treatmentType</h5><p>{e.treatmentType}</p></div>}
                        {e.lopiaType && <div><h5>Root canal treatment Type</h5><p>{e.lopiaType}</p></div>}
                        {e.channal && <div><h5>Canal length</h5><p>{e.channal}</p></div>}
                        {e.cannals && <div><h5>Added Canals</h5><div>{cannalsItems}</div></div>}
                        {e.channalB && <div><h5>B Length</h5><p>{e.channalB}</p></div>}
                        {e.channalP && <div><h5>P Length</h5><p>{e.channalP}</p></div>}
                        {e.channalDB && <div> <h5>DB Length</h5><p>{e.channalDB}</p></div>}
                        {e.channalMB2 && <div><h5>MB2 Length</h5><p>{e.channalMB2}</p></div>}
                        {e.channalMB1 && <div><h5>MB1 Length</h5><p>{e.channalMB1}</p></div>}
                        {e.channalMB && <div><h5>MB Length</h5><p>{e.channalMB}</p></div>}
                        {e.channalL && <div><h5>L Length</h5><p>{e.channalL}</p></div>}
                        {e.channalML && <div><h5>ML Length</h5><p>{e.channalML}</p></div>}
                        {e.channalD && <div><h5>D Length</h5><p>{e.channalD}</p></div>}
                        {e.tarmimMaterial && <div><h5>Restoration Material Type</h5><p>{e.tarmimMaterial}</p></div>}
                        {e.chooseClass && <div><h5>Class Type</h5><p>{e.chooseClass}</p></div>}
                        {e.class2Option && <div><h5>class2 Type</h5><p>{e.class2Option}</p></div>}
                        {e.tagGazafMadan && <div><h5>Porcelain-fused-to-metal Crowns</h5><p>{e.tagGazafMadan}</p></div>}
                        {e.tagGazafiKamel && <div> <h5>All porcelain Crowns</h5><p>{e.tagGazafiKamel}</p></div>}
                        {e.GsrGazafMadan && <div><h5>Porcelain-fused-to-metal Bridge</h5><p>{e.GsrGazafMadan}</p></div>}
                        {e.GsrGazafiKamel && <div><h5>All porcelain Bridge</h5><p>{e.GsrGazafiKamel}</p></div>}
                        {e.Tigan && <div><h5>Crowns</h5><p>{e.Tigan}</p></div>}
                        {e.Gsr && <div><h5>Bridges</h5><p>{e.Gsr}</p></div>}
                        {e.gsrArray && <div><h5>Teeth of Bridge</h5><p>{e.gsrArray}</p></div>}
                        {e.tanzif && <div><h5>Cleaning</h5><p>{e.tanzif}</p></div>}
                        {e.tabeed && <div><h5>Whitening</h5><p>{e.tabeed}</p></div>}
                        {e.kala && <div><h5>Extraction</h5><p>{e.kala}</p></div>}
                        {e.noteLopia && <div><h5>Treatment Notes</h5>{e.noteLopia}<p></p></div>}
                        {e.noteVeneers && <div><h5>Veneers Notes</h5><p>{e.noteVeneers}</p></div>}
                        {e.noteoutclinic && <div> <h5>Notes</h5><p>{e.noteoutclinic}</p></div>}
                        {e.noteTegan && <div><h5>Crowns Notes</h5><p>{e.noteTegan}</p></div>}
                        {e.noteGsoor && <div><h5>Bridges Notes</h5><p>{e.noteGsoor}</p></div>}
                        {e.noteKala && <div><h5>Extraction Notes</h5><p>{e.noteKala}</p></div>}
                        {e.noteTanzif && <div> <h5>Cleaning Notes</h5><p>{e.noteTanzif}</p></div>}
                        {e.noteTabeed && <div><h5>Whitening Notes</h5><p>{e.noteTabeed}</p></div>}
                        {e.noteTarmim && <div><h5>Restoration Notes</h5><p>{e.noteTarmim}</p></div>}
                        {e.channalNote && <div><h5>Canals Notes</h5><p>{e.channalNote}</p></div>}
                        {e.cost && <div><h5>Cost</h5><h5>{e.cost}</h5></div>}
                    </div>
                </div>
            </section >
        )
    })




    /*<table border="1">
                    <thead>
                        <tr>
                            <th>Name</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr key={e.id}>
                            <td>{e.name}</td>
                        </tr>
                    </tbody>
                    <table>
                        <thead>
                            <tr>
                                <th>Date of Session</th>
                                {e.tooth && <th>Tooth</th>}
                                {e.status && <th>Status</th>}
                                {e.inclinic && <th>Place of Treatment</th>}
                                {e.treatmentType && <th>treatmentType</th>}
                                {e.lopiaType && <th>Root canal treatment Type</th>}
                                {e.channal && <th>Canal length</th>}
                                {e.cannals && <th>Added Canals</th>}
                                {e.channalB && <th>B Length</th>}
                                {e.channalP && <th>P Length</th>}
                                {e.channalDB && <th>DB Length</th>}
                                {e.channalMB2 && <th>MB2 Length</th>}
                                {e.channalMB1 && <th>MB1 Length</th>}
                                {e.channalMB && <th>MB Length</th>}
                                {e.channalL && <th>L Length</th>}
                                {e.channalML && <th>ML Length</th>}
                                {e.channalD && <th>D Length</th>}
                                {e.tarmimMaterial && <th>Restoration Material Type</th>}
                                {e.chooseClass && <th>Class Type</th>}
                                {e.class2Option && <th>class2 Type</th>}
                                {e.tagGazafMadan && <th>Porcelain-fused-to-metal Crowns</th>}
                                {e.tagGazafiKamel && <th>All porcelain Crowns</th>}
                                {e.GsrGazafMadan && <th>Porcelain-fused-to-metal Bridge</th>}
                                {e.GsrGazafiKamel && <th>All porcelain Bridge</th>}
                                {e.Tigan && <th>Crowns</th>}
                                {e.Gsr && <th>Bridges</th>}
                                {e.gsrArray && <th>Teeth of Bridge</th>}
                                {e.tanzif && <th>Cleaning</th>}
                                {e.tabeed && <th>Whitening</th>}
                                {e.kala && <th>Extraction</th>}
                                {e.noteLopia && <th>Treatment Notes</th>}
                                {e.noteVeneers && <th>Veneers Notes</th>}
                                {e.noteoutclinic && <th>Notes</th>}
                                {e.noteTegan && <th>Crowns Notes</th>}
                                {e.noteGsoor && <th>Bridges Notes</th>}
                                {e.noteKala && <th>Extraction Notes</th>}
                                {e.noteTanzif && <th>Cleaning Notes</th>}
                                {e.noteTabeed && <th>Whitening Notes</th>}
                                {e.noteTarmim && <th>Restoration Notes</th>}
                                {e.channalNote && <th>Canals Notes</th>}
                                {e.cost && <th>Cost</th>}
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={e.id}>
                                <td>{e.date}</td>
                                {(e.tooth === '1RD' || e.tooth === '1RDP') && <td>{31}</td>}
                                {(e.tooth === '2RD' || e.tooth === '2RDP') && <td>{32}</td>}
                                {(e.tooth === '3RD' || e.tooth === '3RDP') && <td>{33}</td>}
                                {(e.tooth === '4RD' || e.tooth === '4RDP') && <td>{34}</td>}
                                {(e.tooth === '5RD' || e.tooth === '5RDP') && <td>{35}</td>}
                                {(e.tooth === '6RD' || e.tooth === '6RDP') && <td>{36}</td>}
                                {(e.tooth === '7RD' || e.tooth === '7RDP') && <td>{37}</td>}
                                {(e.tooth === '8RD' || e.tooth === '8RDP') && <td>{38}</td>}
                                {(e.tooth === '1LD' || e.tooth === '1LDP') && <td>{41}</td>}
                                {(e.tooth === '2LD' || e.tooth === '2LDP') && <td>{42}</td>}
                                {(e.tooth === '3LD' || e.tooth === '3LDP') && <td>{43}</td>}
                                {(e.tooth === '4LD' || e.tooth === '4LDP') && <td>{44}</td>}
                                {(e.tooth === '5LD' || e.tooth === '5LDP') && <td>{45}</td>}
                                {(e.tooth === '6LD' || e.tooth === '6LDP') && <td>{46}</td>}
                                {(e.tooth === '7LD' || e.tooth === '7LDP') && <td>{47}</td>}
                                {(e.tooth === '8LD' || e.tooth === '8LDP') && <td>{48}</td>}
                                {(e.tooth === '1RU' || e.tooth === '1RUP') && <td>{21}</td>}
                                {(e.tooth === '2RU' || e.tooth === '2RUP') && <td>{22}</td>}
                                {(e.tooth === '3RU' || e.tooth === '3RUP') && <td>{23}</td>}
                                {(e.tooth === '4RU' || e.tooth === '4RUP') && <td>{24}</td>}
                                {(e.tooth === '5RU' || e.tooth === '5RUP') && <td>{25}</td>}
                                {(e.tooth === '6RU' || e.tooth === '6RUP') && <td>{26}</td>}
                                {(e.tooth === '7RU' || e.tooth === '7RUP') && <td>{27}</td>}
                                {(e.tooth === '8RU' || e.tooth === '8RUP') && <td>{28}</td>}
                                {(e.tooth === '1LU' || e.tooth === '1LUP') && <td>{11}</td>}
                                {(e.tooth === '2LU' || e.tooth === '2LUP') && <td>{12}</td>}
                                {(e.tooth === '3LU' || e.tooth === '3LUP') && <td>{13}</td>}
                                {(e.tooth === '4LU' || e.tooth === '4LUP') && <td>{14}</td>}
                                {(e.tooth === '5LU' || e.tooth === '5LUP') && <td>{15}</td>}
                                {(e.tooth === '6LU' || e.tooth === '6LUP') && <td>{16}</td>}
                                {(e.tooth === '7LU' || e.tooth === '7LUP') && <td>{17}</td>}
                                {(e.tooth === '8LU' || e.tooth === '8LUP') && <td>{18}</td>}
                                {(e.tooth === '1RUT' || e.tooth === '1RUTP') && <td>{51}</td>}
                                {(e.tooth === '2RUT' || e.tooth === '2RUTP') && <td>{52}</td>}
                                {(e.tooth === '3RUT' || e.tooth === '3RUTP') && <td>{53}</td>}
                                {(e.tooth === '4RUT' || e.tooth === '4RUTP') && <td>{54}</td>}
                                {(e.tooth === '5RUT' || e.tooth === '5RUTP') && <td>{55}</td>}
                                {(e.tooth === '1LUT' || e.tooth === '1LUTP') && <td>{61}</td>}
                                {(e.tooth === '2LUT' || e.tooth === '2LUTP') && <td>{62}</td>}
                                {(e.tooth === '3LUT' || e.tooth === '3LUTP') && <td>{63}</td>}
                                {(e.tooth === '4LUT' || e.tooth === '4LUTP') && <td>{64}</td>}
                                {(e.tooth === '5LUT' || e.tooth === '5LUTP') && <td>{65}</td>}
                                {(e.tooth === '1RDT' || e.tooth === '1RDTP') && <td>{81}</td>}
                                {(e.tooth === '2RDT' || e.tooth === '2RDTP') && <td>{82}</td>}
                                {(e.tooth === '3RDT' || e.tooth === '3RDTP') && <td>{83}</td>}
                                {(e.tooth === '4RDT' || e.tooth === '4RDTP') && <td>{84}</td>}
                                {(e.tooth === '5RDT' || e.tooth === '5RDTP') && <td>{85}</td>}
                                {(e.tooth === '1LDT' || e.tooth === '1LDTP') && <td>{71}</td>}
                                {(e.tooth === '2LDT' || e.tooth === '2LDTP') && <td>{72}</td>}
                                {(e.tooth === '3LDT' || e.tooth === '3LDTP') && <td>{73}</td>}
                                {(e.tooth === '4LDT' || e.tooth === '4LDTP') && <td>{74}</td>}
                                {(e.tooth === '5LDT' || e.tooth === '5LDTP') && <td>{75}</td>}
                                {e.status && <td>{e.status}</td>}
                                {e.inclinic && <td>{e.inclinic}</td>}
                                {e.treatmentType && <td>{e.treatmentType}</td>}
                                {e.lopiaType && <td>{e.lopiaType}</td>}
                                {e.channal && <td>{e.channal}</td>}
                                {e.cannals && <div>{cannalsItems}</div>}
                                {e.channalB && <td>{e.channalB}</td>}
                                {e.channalP && <td>{e.channalP}</td>}
                                {e.channalDB && <td>{e.channalDB}</td>}
                                {e.channalMB2 && <td>{e.channalMB2}</td>}
                                {e.channalMB1 && <td>{e.channalMB1}</td>}
                                {e.channalMB && <td>{e.channalMB}</td>}
                                {e.channalL && <td>{e.channalL}</td>}
                                {e.channalML && <td>{e.channalML}</td>}
                                {e.channalD && <td>{e.channalD}</td>}
                                {e.tarmimMaterial && <td>{e.tarmimMaterial}</td>}
                                {e.chooseClass && <td>{e.chooseClass}</td>}
                                {e.class2Option && <td>{e.class2Option}</td>}
                                {e.tagGazafMadan && <td>{e.tagGazafMadan}</td>}
                                {e.tagGazafiKamel && <td>{e.tagGazafiKamel}</td>}
                                {e.GsrGazafMadan && <td>{e.GsrGazafMadan}</td>}
                                {e.GsrGazafiKamel && <td>{e.GsrGazafiKamel}</td>}
                                {e.Tigan && <td>{e.Tigan}</td>}
                                {e.Gsr && <td>{e.Gsr}</td>}
                                {e.gsrArray && <td>{e.gsrArray}</td>}
                                {e.tanzif && <td>{e.tanzif}</td>}
                                {e.tabeed && <td>{e.tabeed}</td>}
                                {e.kala && <td>{e.kala}</td>}
                                {e.noteLopia && <td>{e.noteLopia}</td>}
                                {e.noteVeneers && <td>{e.noteVeneers}</td>}
                                {e.noteoutclinic && <td>{e.noteoutclinic}</td>}
                                {e.noteTegan && <td>{e.noteTegan}</td>}
                                {e.noteGsoor && <td>{e.noteGsoor}</td>}
                                {e.noteKala && <td>{e.noteKala}</td>}
                                {e.noteTanzif && <td>{e.noteTanzif}</td>}
                                {e.noteTabeed && <td>{e.noteTabeed}</td>}
                                {e.noteTarmim && <td>{e.noteTarmim}</td>}
                                {e.channalNote && <td>{e.channalNote}</td>}
                                {e.cost && <td>{e.cost}</td>}
                            </tr>
                        </tbody>
                    </table>
                </table>
            </section >
        )
    })
*/





    {/* const data = infoooPatientsArray.map((patientData) => {
        return (
            <table border="1">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Age</th>
                        <th>Gender</th>
                        <th>Phone</th>
                        <th>Notes</th>
                        <th>Costs</th>
                        <th>Payments</th>
                        <th>Sessions Num</th>

                    </tr>
                </thead>
                <tbody>
                    <tr key={patientData.id}>
                        <td>{patientData.name}</td>
                        <td>{patientData.age}</td>
                        <td>{patientData.sex}</td>
                        <td>{patientData.phone}</td>
                        <td>{patientData.notes}</td>
                        <td>{patientData.costssum}</td>
                        <td>{patientData.paymentssum}</td>
                        <td>{patientData.sessionsnum}</td>
                    </tr>
                </tbody>
                <h1>Treatments</h1>
                {console.log(`InfoSessions ${infoooSessionsArray}`)}
                {infoooSessionsArray.map(async (sessionData) => {
                    { console.log(`InfoTreatment ${JSON.stringify(infoooTreatmentsArray)}`) }
                    let treatmentArray = []
                    await fetch(`https://hassan-mohammad.tech/DoctorClinic/php/getidTreats.php?sessionid=${sessionData.id}&userid=${patientData.id}&loginuserid=${id}`,
                        {
                            headers: {
                                "Content-Type": "text/html",
                                "charset": "utf-8"
                            },
                        }
                    )
                        .then((response) => {
                            if (!response.ok) {
                                throw Error('Could not fetch the data')

                            }
                            else if (response.ok) {
                                return response.json()
                            }
                        })
                        .then((data) => {
                            if (data.successful) {
                                data.values.map((e) => {
                                    treatmentArray.push(e)
                                    infoooTreatmentsArray.push(e)
                                })
                                setMessage('Done')
                            }
                            return setInfoooTreatments(data.values)

                        })
                        .catch(err => {
                            setMessage(err)
                        })
                    return (
                        infoooTreatmentsArray.map((treatmentData) => {
                            return (
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date of Session</th>
                                            {treatmentData.tooth && <th>Tooth</th>}
                                            {treatmentData.status && <th>Status</th>}
                                            {treatmentData.inclinic && <th>Place of Treatment</th>}
                                            {treatmentData.treatmentType && <th>treatmentType</th>}
                                            {treatmentData.lopiaType && <th>Root canal treatment Type</th>}
                                            {treatmentData.channal && <th>Canal length</th>}
                                            {treatmentData.cannals && <th>Added Canals</th>}
                                            {treatmentData.channalB && <th>B Length</th>}
                                            {treatmentData.channalP && <th>P Length</th>}
                                            {treatmentData.channalDB && <th>DB Length</th>}
                                            {treatmentData.channalMB2 && <th>MB2 Length</th>}
                                            {treatmentData.channalMB1 && <th>MB1 Length</th>}
                                            {treatmentData.channalMB && <th>MB Length</th>}
                                            {treatmentData.channalL && <th>L Length</th>}
                                            {treatmentData.channalML && <th>ML Length</th>}
                                            {treatmentData.channalD && <th>D Length</th>}
                                            {treatmentData.tarmimMaterial && <th>Restoration Material Type</th>}
                                            {treatmentData.chooseClass && <th>Class Type</th>}
                                            {treatmentData.class2Option && <th>class2 Type</th>}
                                            {treatmentData.tagGazafMadan && <th>Porcelain-fused-to-metal Crowns</th>}
                                            {treatmentData.tagGazafiKamel && <th>All porcelain Crowns</th>}
                                            {treatmentData.GsrGazafMadan && <th>Porcelain-fused-to-metal Bridge</th>}
                                            {treatmentData.GsrGazafiKamel && <th>All porcelain Bridge</th>}
                                            {treatmentData.Tigan && <th>Crowns</th>}
                                            {treatmentData.Gsr && <th>Bridges</th>}
                                            {treatmentData.gsrArray && <th>Teeth of Bridge</th>}
                                            {treatmentData.tanzif && <th>Cleaning</th>}
                                            {treatmentData.tabeed && <th>Whitening</th>}
                                            {treatmentData.kala && <th>Extraction</th>}
                                            {treatmentData.noteLopia && <th>Treatment Notes</th>}
                                            {treatmentData.noteVeneers && <th>Veneers Notes</th>}
                                            {treatmentData.noteoutclinic && <th>Notes</th>}
                                            {treatmentData.noteTegan && <th>Crowns Notes</th>}
                                            {treatmentData.noteGsoor && <th>Bridges Notes</th>}
                                            {treatmentData.noteKala && <th>Extraction Notes</th>}
                                            {treatmentData.noteTanzif && <th>Cleaning Notes</th>}
                                            {treatmentData.noteTabeed && <th>Whitening Notes</th>}
                                            {treatmentData.noteTarmim && <th>Restoration Notes</th>}
                                            {treatmentData.channalNote && <th>Canals Notes</th>}
                                            {treatmentData.cost && <th>Cost</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr key={sessionData.id}>
                                            <td>{sessionData.date}</td>
                                            {(treatmentData.tooth === '1RD' || treatmentData.tooth === '1RDP') && <td>{31}</td>}
                                            {(treatmentData.tooth === '2RD' || treatmentData.tooth === '2RDP') && <td>{32}</td>}
                                            {(treatmentData.tooth === '3RD' || treatmentData.tooth === '3RDP') && <td>{33}</td>}
                                            {(treatmentData.tooth === '4RD' || treatmentData.tooth === '4RDP') && <td>{34}</td>}
                                            {(treatmentData.tooth === '5RD' || treatmentData.tooth === '5RDP') && <td>{35}</td>}
                                            {(treatmentData.tooth === '6RD' || treatmentData.tooth === '6RDP') && <td>{36}</td>}
                                            {(treatmentData.tooth === '7RD' || treatmentData.tooth === '7RDP') && <td>{37}</td>}
                                            {(treatmentData.tooth === '8RD' || treatmentData.tooth === '8RDP') && <td>{38}</td>}
                                            {(treatmentData.tooth === '1LD' || treatmentData.tooth === '1LDP') && <td>{41}</td>}
                                            {(treatmentData.tooth === '2LD' || treatmentData.tooth === '2LDP') && <td>{42}</td>}
                                            {(treatmentData.tooth === '3LD' || treatmentData.tooth === '3LDP') && <td>{43}</td>}
                                            {(treatmentData.tooth === '4LD' || treatmentData.tooth === '4LDP') && <td>{44}</td>}
                                            {(treatmentData.tooth === '5LD' || treatmentData.tooth === '5LDP') && <td>{45}</td>}
                                            {(treatmentData.tooth === '6LD' || treatmentData.tooth === '6LDP') && <td>{46}</td>}
                                            {(treatmentData.tooth === '7LD' || treatmentData.tooth === '7LDP') && <td>{47}</td>}
                                            {(treatmentData.tooth === '8LD' || treatmentData.tooth === '8LDP') && <td>{48}</td>}
                                            {(treatmentData.tooth === '1RU' || treatmentData.tooth === '1RUP') && <td>{21}</td>}
                                            {(treatmentData.tooth === '2RU' || treatmentData.tooth === '2RUP') && <td>{22}</td>}
                                            {(treatmentData.tooth === '3RU' || treatmentData.tooth === '3RUP') && <td>{23}</td>}
                                            {(treatmentData.tooth === '4RU' || treatmentData.tooth === '4RUP') && <td>{24}</td>}
                                            {(treatmentData.tooth === '5RU' || treatmentData.tooth === '5RUP') && <td>{25}</td>}
                                            {(treatmentData.tooth === '6RU' || treatmentData.tooth === '6RUP') && <td>{26}</td>}
                                            {(treatmentData.tooth === '7RU' || treatmentData.tooth === '7RUP') && <td>{27}</td>}
                                            {(treatmentData.tooth === '8RU' || treatmentData.tooth === '8RUP') && <td>{28}</td>}
                                            {(treatmentData.tooth === '1LU' || treatmentData.tooth === '1LUP') && <td>{11}</td>}
                                            {(treatmentData.tooth === '2LU' || treatmentData.tooth === '2LUP') && <td>{12}</td>}
                                            {(treatmentData.tooth === '3LU' || treatmentData.tooth === '3LUP') && <td>{13}</td>}
                                            {(treatmentData.tooth === '4LU' || treatmentData.tooth === '4LUP') && <td>{14}</td>}
                                            {(treatmentData.tooth === '5LU' || treatmentData.tooth === '5LUP') && <td>{15}</td>}
                                            {(treatmentData.tooth === '6LU' || treatmentData.tooth === '6LUP') && <td>{16}</td>}
                                            {(treatmentData.tooth === '7LU' || treatmentData.tooth === '7LUP') && <td>{17}</td>}
                                            {(treatmentData.tooth === '8LU' || treatmentData.tooth === '8LUP') && <td>{18}</td>}
                                            {(treatmentData.tooth === '1RUT' || treatmentData.tooth === '1RUTP') && <td>{51}</td>}
                                            {(treatmentData.tooth === '2RUT' || treatmentData.tooth === '2RUTP') && <td>{52}</td>}
                                            {(treatmentData.tooth === '3RUT' || treatmentData.tooth === '3RUTP') && <td>{53}</td>}
                                            {(treatmentData.tooth === '4RUT' || treatmentData.tooth === '4RUTP') && <td>{54}</td>}
                                            {(treatmentData.tooth === '5RUT' || treatmentData.tooth === '5RUTP') && <td>{55}</td>}
                                            {(treatmentData.tooth === '1LUT' || treatmentData.tooth === '1LUTP') && <td>{61}</td>}
                                            {(treatmentData.tooth === '2LUT' || treatmentData.tooth === '2LUTP') && <td>{62}</td>}
                                            {(treatmentData.tooth === '3LUT' || treatmentData.tooth === '3LUTP') && <td>{63}</td>}
                                            {(treatmentData.tooth === '4LUT' || treatmentData.tooth === '4LUTP') && <td>{64}</td>}
                                            {(treatmentData.tooth === '5LUT' || treatmentData.tooth === '5LUTP') && <td>{65}</td>}
                                            {(treatmentData.tooth === '1RDT' || treatmentData.tooth === '1RDTP') && <td>{81}</td>}
                                            {(treatmentData.tooth === '2RDT' || treatmentData.tooth === '2RDTP') && <td>{82}</td>}
                                            {(treatmentData.tooth === '3RDT' || treatmentData.tooth === '3RDTP') && <td>{83}</td>}
                                            {(treatmentData.tooth === '4RDT' || treatmentData.tooth === '4RDTP') && <td>{84}</td>}
                                            {(treatmentData.tooth === '5RDT' || treatmentData.tooth === '5RDTP') && <td>{85}</td>}
                                            {(treatmentData.tooth === '1LDT' || treatmentData.tooth === '1LDTP') && <td>{71}</td>}
                                            {(treatmentData.tooth === '2LDT' || treatmentData.tooth === '2LDTP') && <td>{72}</td>}
                                            {(treatmentData.tooth === '3LDT' || treatmentData.tooth === '3LDTP') && <td>{73}</td>}
                                            {(treatmentData.tooth === '4LDT' || treatmentData.tooth === '4LDTP') && <td>{74}</td>}
                                            {(treatmentData.tooth === '5LDT' || treatmentData.tooth === '5LDTP') && <td>{75}</td>}
                                            {treatmentData.status && <td>{treatmentData.status}</td>}
                                            {treatmentData.inclinic && <td>{treatmentData.inclinic}</td>}
                                            {treatmentData.treatmentType && <td>{treatmentData.treatmentType}</td>}
                                            {treatmentData.lopiaType && <td>{treatmentData.lopiaType}</td>}
                                            {treatmentData.channal && <td>{treatmentData.channal}</td>}
                                            {/*treatmentData.cannals &&
                                                <div>
                                                    {treatmentData.cannals.map((e) => {
                                                        return (
                                                            <td>{e}</td>
                                                        )
                                                    })}
                                                </div>
                                            //}
                              //              {treatmentData.channalB && <td>{treatmentData.channalB}</td>}
                            //                {treatmentData.channalP && <td>{treatmentData.channalP}</td>}
                          //                  {treatmentData.channalDB && <td>{treatmentData.channalDB}</td>}
                        //                    {treatmentData.channalMB2 && <td>{treatmentData.channalMB2}</td>}
                      //                      {treatmentData.channalMB1 && <td>{treatmentData.channalMB1}</td>}
                    //                        {treatmentData.channalMB && <td>{treatmentData.channalMB}</td>}
                  //                          {treatmentData.channalL && <td>{treatmentData.channalL}</td>}
                //                            {treatmentData.channalML && <td>{treatmentData.channalML}</td>}
              //                              {treatmentData.channalD && <td>{treatmentData.channalD}</td>}
            //                                {treatmentData.tarmimMaterial && <td>{treatmentData.tarmimMaterial}</td>}
          //                                  {treatmentData.chooseClass && <td>{treatmentData.chooseClass}</td>}
        //                                    {treatmentData.class2Option && <td>{treatmentData.class2Option}</td>}
      //                                      {treatmentData.tagGazafMadan && <td>{treatmentData.tagGazafMadan}</td>}
    //                                        {treatmentData.tagGazafiKamel && <td>{treatmentData.tagGazafiKamel}</td>}
  //                                          {treatmentData.GsrGazafMadan && <td>{treatmentData.GsrGazafMadan}</td>}
//                                            {treatmentData.GsrGazafiKamel && <td>{treatmentData.GsrGazafiKamel}</td>}
                                            //{treatmentData.Tigan && <td>{treatmentData.Tigan}</td>}
                                            //{treatmentData.Gsr && <td>{treatmentData.Gsr}</td>}
                                           // {treatmentData.gsrArray && <td>{treatmentData.gsrArray}</td>}
                                         //   {treatmentData.tanzif && <td>{treatmentData.tanzif}</td>}
                                       //     {treatmentData.tabeed && <td>{treatmentData.tabeed}</td>}
                                     //       {treatmentData.kala && <td>{treatmentData.kala}</td>}
                                   //         {treatmentData.noteLopia && <td>{treatmentData.noteLopia}</td>}
                                 //           {treatmentData.noteVeneers && <td>{treatmentData.noteVeneers}</td>}
                               //             {treatmentData.noteoutclinic && <td>{treatmentData.noteoutclinic}</td>}
                             //               {treatmentData.noteTegan && <td>{treatmentData.noteTegan}</td>}
                           //                 {treatmentData.noteGsoor && <td>{treatmentData.noteGsoor}</td>}
                         //                   {treatmentData.noteKala && <td>{treatmentData.noteKala}</td>}
                       //                     {treatmentData.noteTanzif && <td>{treatmentData.noteTanzif}</td>}
                     //                       {treatmentData.noteTabeed && <td>{treatmentData.noteTabeed}</td>}
                   //                         {treatmentData.noteTarmim && <td>{treatmentData.noteTarmim}</td>}
                 //                           {treatmentData.channalNote && <td>{treatmentData.channalNote}</td>}
               //                             {treatmentData.cost && <td>{treatmentData.cost}</td>}
              //                          </tr>
            //                        </tbody>
            //                    </table>
          //                  )
          //              })
          //          )
          //      })}
       //     </table>
        //)
    //})
    */}









    const handlePrint = () => {
        const element = document.getElementById('pdf-content');
        window.print(element);
    };






    const downloadPDF = () => {
        const element = document.getElementById('pdf-content');
        const aaaa = {
            margin: 2,
            filename: 'my-document.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        }
        const opt = {
            margin: 0.2,
            filename: 'data-report.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 1 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        html2pdf().set(aaaa).from(element).save();
    };

    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1240px)'
    })
    const isSmallLap = useMediaQuery({
        query: '(min-width: 1224px) and (max-width: 1240px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })

    useEffect(() => {
        getAllData()
    }, [])

    return (
        <div className='container-download'>
            {isDesktopOrLaptop && <div className='exportAndImportContainer'>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button className='btn btn-dark' onClick={back}><IoMdArrowRoundBack /></button>
                </div>
                <span className='titleExporImportAndBtns'>
                    <h4 className='titleExporImport'>Export and import your data from database (Backup):</h4>
                    {message === 'Loading...' && <div className="loading-all">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>}
                </span>
                <div className='exportAndImport'>
                    <h5 className='label'>Export and download my data from the database:</h5>
                    <button title='Export data from database' className='btn btn-success' onClick={handleExport}>Export and download CSV file<BiSolidFileImport /></button>
                </div>
                <div className='exportAndImport'>
                    <h5 className='label'>Import my data from CSV file to the database:</h5>
                    <ImportData />
                </div>
            </div>}
            {isTabletOrMobile && <div className='exportAndImportContainer'>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button className='btn btn-dark' onClick={back}><IoMdArrowRoundBack /></button>
                </div>
                <span className='titleExporImportAndBtns'>
                    <h5 className='titleExporImport'>Export and import your data from database (Backup):</h5>
                    {message === 'Loading...' && <div className="loading-all">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>}
                </span>
                <div className='exportAndImport'>
                    <h6 className='label'>Export and download my data from the database:</h6>
                    <button title='Export data from database' className='btn btn-success' onClick={handleExport}>Export and download CSV file<BiSolidFileImport /></button>
                </div>
                <div className='exportAndImport'>
                    <h6 className='label'>Import my data from CSV file to the database:</h6>
                    <ImportData />
                </div>
            </div>}
        </div>
    )
}

//                    <button title='Print' className='btn btn-primary' disabled={message === 'Loading...'} onClick={handlePrint}><IoMdPrint /></button>


/* <div className='pdf-file-container'>
                <h6>My data:</h6>
                    {infoooPatients && <div id="pdf-content" className='pdf-content-file'>
                        <h4>My Patients</h4>
                        {patientData}
                        <h4>Treatments</h4>
                        {treatmentsPatientsData}
                        <h4>Payments</h4>
                        {paymentsData}
                    </div>}
                    {!infoooPatients && <div>No Data</div>}
                </div>*/